import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import { AxlPanel } from 'axl-reactjs-ui';

import styles from './styles';
import ShipmentDropoffWhat3WordsInfo from '../../ShipmentDropoffWhat3WordsInfo';
import CorrectedValue from '../../CorrectedValue';

@inject('userStore', 'jobStore')
@observer
class ShipmentDropoffInfo extends Component {
  render() {
    const { shipment, userStore, jobStore } = this.props;
    const { blurCustomerAddress } = userStore;
    const isDropoffError = !shipment.dropoff_address.lat || !shipment.dropoff_address.lng || shipment.status === 'UNSERVICEABLE';
    const blurStyle = blurCustomerAddress ? styles.textBlur : {};
    const { dropoff_address } = shipment;
    const { listCorrectedAddress } = jobStore;
    const correctedInfo = listCorrectedAddress?.find(d => d?.id === shipment.customer_profile_id)?.corrected_address || dropoff_address;
    const originStreet = dropoff_address?.street || '';
    const originStreet2 = dropoff_address?.street2 || '';
    const originAddressLine2 = `${dropoff_address?.city}, ${dropoff_address?.state} ${dropoff_address?.zipcode}`;
    const correctedStreet = correctedInfo?.street || '';
    const correctedStreet2 = correctedInfo?.street2 || '';
    const correctedAddressLine2 = `${correctedInfo?.city}, ${correctedInfo?.state} ${correctedInfo?.zipcode}`;

    return (
      <AxlPanel style={styles.panelContainer}>
        <div style={styles.panelHeader}>
          <div style={styles.panelHeaderTitle}>{`Dropoff Info:`}</div>
        </div>
        <AxlPanel.Row style={styles.panelContent}>
          <AxlPanel.Col flex={1}>
            <AxlPanel.Row style={styles.row}>
              <AxlPanel.Col>
                <div
                  style={{
                    ...styles.text,
                    ...{ color: isDropoffError ? 'red' : '#000' },
                    ...blurStyle,
                  }}
                >
                  <CorrectedValue originValue={originStreet} correctedValue={correctedStreet} />
                  <CorrectedValue originValue={originStreet2} correctedValue={correctedStreet2} />
                </div>
                <div>
                  <CorrectedValue originValue={originAddressLine2} correctedValue={correctedAddressLine2} />
                </div>
              </AxlPanel.Col>
              {shipment.dropoff_note && (
                <AxlPanel.Col>
                  <div style={styles.noteLabel}>{`NOTES`}</div>
                  <div style={styles.noteContent}>{shipment.dropoff_note}</div>
                </AxlPanel.Col>
              )}
            </AxlPanel.Row>
            <ShipmentDropoffWhat3WordsInfo shipment={shipment} />
            <AxlPanel.Row>
              <AxlPanel.Col>
                <AxlPanel.Row style={styles.timewindow}>
                  <AxlPanel.Col flex={2}>
                    <div style={styles.timeLabel}>{`Time Window:`}</div>
                    <div>
                      {moment(shipment.dropoff_earliest_ts).format('MM/DD/YY @ HH:mm A')} - {moment(shipment.dropoff_latest_ts).format('HH:mm A')}
                    </div>
                  </AxlPanel.Col>
                  <AxlPanel.Col flex={1}>
                    <div style={styles.timeLabel}>{`Time Buffer:`}</div>
                    <div> {shipment && shipment.dropoff_buffer && <span>{shipment.dropoff_buffer}</span>}</div>
                  </AxlPanel.Col>
                </AxlPanel.Row>
              </AxlPanel.Col>
            </AxlPanel.Row>
            <AxlPanel.Row>
              <AxlPanel.Col>
                <b>{`Delivery Photo?`}</b>
                <div>{shipment.delivery_proof_photo_required !== undefined ? (shipment.delivery_proof_photo_required ? 'Yes' : 'No') : '-'}</div>
              </AxlPanel.Col>
              <AxlPanel.Col>
                <b>{`Signature?`}</b>
                <div>{shipment.signature_required !== undefined ? (shipment.signature_required ? 'Yes' : 'No') : '-'}</div>
              </AxlPanel.Col>
              <AxlPanel.Col>
                <b>{`SMS enabled?`}</b>
                <div>{shipment.sms_enabled !== undefined ? (shipment.sms_enabled ? 'Yes' : 'No') : '-'}</div>
              </AxlPanel.Col>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    );
  }
}

export default ShipmentDropoffInfo;
